import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 161,
	height: 161,
	viewBox: "0 0 161 161",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 160,
		height: 160,
		rx: 80,
		fill: "#1377E7",
		stroke: "#1377E7"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M77.7027 83.2963H60.9189V77.7017H77.7027V60.918H83.2973V77.7017H100.081V83.2963H83.2973V100.08H77.7027V83.2963Z",
		fill: "white"
	})]
});
export default SvgPlusIcon;
